<template>
  <div class="container">
    <!-- 面包屑 -->
    <div class="integralBreadcrumb">
      <div class="integralBreadcrumb-item" @click="routerHandle('basicInfo')">个人中心</div>
      <div class="el-icon-arrow-right jt"></div>
      <div class="integralBreadcrumb-item" @click="routerHandle('equipmentList', 'productionDataManagement')">设备管理</div>
      <div class="el-icon-arrow-right jt"></div>
      <div class="integralBreadcrumb-item">详情</div>
    </div>
    <!-- 设备信息 -->
    <div class="body-info" v-if="detailInfo">
      <h2>设备信息</h2>
      <div class="row">
        <div class="row-item">
          <span class="row-item-label">设备编号：</span>
          <label class="row-item-input">{{detailInfo.equipmentCode}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">设备名称：</span>
          <label class="row-item-input">{{detailInfo.equipmentName}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">设备状态：</span>
          <label class="row-item-input" v-if="detailInfo.equipmentStatus === '0'">正常</label>
          <label class="row-item-input" v-else-if="detailInfo.equipmentStatus === '1'">维修</label>
          <label class="row-item-input" v-else-if="detailInfo.equipmentStatus === '2'">闲置</label>
          <label class="row-item-input" v-else-if="detailInfo.equipmentStatus === '3'">报废</label>
        </div>
      </div>
      <div class="row">
        <div class="row-item">
          <span class="row-item-label">设备类别：</span>
          <label class="row-item-input">{{detailInfo.equipmentType}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">折旧率：</span>
          <label class="row-item-input">{{detailInfo.depreciationRate}}%</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">产品型号：</span>
          <label class="row-item-input">{{detailInfo.productModel}}</label>
        </div>
      </div>
      <div class="row">
        <div class="row-item">
          <span class="row-item-label">设备规格：</span>
          <label class="row-item-input">{{detailInfo.equipmentSpecification}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">价格：</span>
          <label class="row-item-input">{{detailInfo.price || 0}}元</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">录入时间：</span>
          <label class="row-item-input">{{detailInfo.createTime}}</label>
        </div>
      </div>
      <div class="row">
        <div class="row-item">
          <span class="row-item-label">出厂编码：</span>
          <label class="row-item-input">{{detailInfo.factoryCode}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">出厂时间：</span>
          <label class="row-item-input">{{detailInfo.produceDate}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">供应商：</span>
          <label class="row-item-input">{{detailInfo.supplier}}</label>
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="row-item">
          <span class="row-item-label">隶属工作中心：</span>
          <label class="row-item-input">{{detailInfo.subordinateWorkingArea}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">隶属车间：</span>
          <label class="row-item-input">{{detailInfo.subordinateWorkshop}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">设备位置：</span>
          <label class="row-item-input">{{detailInfo.coordinatePosition}}</label>
        </div>
      </div>
      <div class="row">
        <div class="row-item">
          <span class="row-item-label">所属区域：</span>
          <label class="row-item-textarea">{{detailInfo.subordinateArea}}</label>
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="row-item">
          <span class="row-item-label">责任角色：</span>
          <label class="row-item-input">{{detailInfo.responsibilityRole}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">设备责任人：</span>
          <label class="row-item-input">{{detailInfo.equipmentManager}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">班组选择：</span>
          <label class="row-item-input">{{detailInfo.team}}</label>
        </div>
      </div>
      <!-- <div class="row">
        <div class="row-item">
          <span class="row-item-label">最后修改时间：</span>
          <label class="row-item-input">{{detailInfo.modifyTime}}</label>
        </div>
        <div class="row-item">
          <span class="row-item-label">最后修改人：</span>
          <label class="row-item-input">{{detailInfo.modifyUserName}}</label>
        </div>
      </div> -->
      <br/>
      <div class="row">
        <div class="row-item">
          <span class="row-item-label">备注：</span>
          <label class="row-item-input">{{detailInfo.remark || '无'}}</label>
        </div>
      </div>
    </div>
    <!-- 维修计划信息 -->
    <div class="body-info" v-if="detailInfo">
      <h2>设备维修履历</h2>
      <el-table :data="detailInfo.repairInfoList" border v-if="detailInfo.repairInfoList">
        <el-table-column prop="repairCode" header-align="center" align="center" label="维修计划单单号"></el-table-column>
        <el-table-column prop="nextOverhaulTime" header-align="center" align="center" label="检维修时间" :formatter="formatterDate"></el-table-column>
        <el-table-column prop="overhaulStatus" header-align="center" align="center" label="检维修状态">
          <template slot-scope="scope">
            <span v-if="scope.row.overhaulStatus === 0">执行</span>
            <span v-else-if="scope.row.overhaulStatus === 1">送审</span>
            <span v-else>完成</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="detailHandle(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="repairInfoSS(scope.row)" v-if="scope.row.overhaulStatus === 0">送审</el-button>
            <el-button type="text" size="small" @click="repairInfoDone(scope.row)" v-if="scope.row.overhaulStatus === 1">完成</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="row" style="display:flex;justify-content: center;">
      <button class="row-opt-but" style="margin-right:10px;">取消</button>
      <button class="row-opt-but" style="background-color:#1D65A8;color:#fff">确定</button>
    </div> -->
    <Repair ref="repair" v-if="repairVisible" @refreshData="getInfo"></Repair>
  </div>
</template>
<script>
import {formatDate} from '@/utils/validate'
import Repair from './pmequimentrepairinfo-detail'
export default {
  data () {
    return {
      detailInfo: null,
      repairVisible: true
    }
  },
  computed: {
    equipmentId () {
      return this.$route.query.id
    }
  },
  components: {
    Repair
  },
  watch: {
    equipmentId (val) {
      if (val) {
        this.getInfo()
      } else {
        this.formatFormData()
      }
    }
  },
  created () {
    if (this.equipmentId) {
      this.getInfo()
    }
  },
  methods: {
    formatterDate (row, column, value) {
      return formatDate(value)
    },
    getInfo () {
      // this.repairVisible = false
      this.$http.get(`/front/sys/productequipment/pmequipment/viewPmEquipmentDetail/${this.equipmentId}`)
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.detailInfo = data.data || {}
          } else {
            this.detailInfo = {}
          }
        })
        .catch(() => {})
    },
    // getRepairinfo () {
    //   this.$http.get(`${window.SITE_CONFIG["forumURL"]}/productequipment/pmequipmentrepairinfo/info/${this.equipmentId}`)
    //   .then(data => {
    //     if (data && data.result && data.result.code === 0) {
    //       this.repairList = data.result.data.flowingEntityList || []
    //     } else {
    //       this.repairList = []
    //       this.$message.error(data.result.msg)
    //     }
    //   })
    //   .catch(err => {})
    // },
    // 格式化数据
    formatFormData () {
      this.detailInfo = {
        "coordinatePosition": "",
        "depreciationRate": "",
        "equipmentCode": "",
        "equipmentManager": "",
        "equipmentName": "",
        "equipmentSpecification": "",
        "equipmentStatus": 0,
        "equipmentType": "",
        "id": "",
        "nextOverhaulTime": "",
        "overhaulStatus": 0,
        "price": '',
        "productModel": "",
        "remark": "",
        'factoryCode': '',
        'produceDate': '',
        'supplier': '',
        "repairCode": "",
        "repairInfoList": [],
        "responsibilityRole": "",
        "subordinateArea": "",
        "subordinateWorkingArea": "",
        "subordinateWorkshop": "",
        "team": ""
      }
    },
    detailHandle (item) {
      this.repairVisible = true
      this.$nextTick(() => {
        this.$refs.repair.dataForm.id = item.id || 0
        this.$refs.repair.preId = 0
        this.$refs.repair.init()
      })
    },
    // 维保信息送审
    repairInfoSS (item) {
      this.$http.post(`/front/sys/productequipment/pmequipment/pmequipmentrepairinfo/changeEquipmentRepairStatus`, {
        id: item.id,
        overhaulStatus: 1
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.$message.success('送审成功')
            this.getInfo()
          }
        })
        .catch(() => {})
    },
    // 维保信息完成
    repairInfoDone (item) {
      this.repairVisible = true
      this.$nextTick(() => {
        this.$refs.repair.dataForm.id = 0
        this.$refs.repair.preId = item.id
        this.$refs.repair.init()
      })
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        this.$router.push({name: name})
      } else {
        this.formatFormData()
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style scoped>
.container{
  word-wrap: break-word;
  word-break: break-all;
}
.body-conent{
  margin: 20px 0;
}
.body-info h2{
  font-size: 20px;
  color: #333333;
  margin-bottom: 40px;
}
.body-info{
  margin: 10px 0;
  width: 100%;
  padding: 40px 70px;
  background-color: #fff;
}
.row{
  display: flex;
  margin: 10px 0;
  line-height: 36px;
  font-size: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.row-item{
  min-width: 350px;
  display: flex;
  /* height: 36px; */
}
.row-item-label{
  display: inline-block;
  width: 120px;
  text-align: right;
  font-size: 14px;
  color: #666;
}
.row-item-input{
  font-size: 14px;
  min-width: 210px;
  max-width: 930px;
  color: #333;
  /* border: 1px solid #eee; */
  padding-left: 10px;
}
.row-item-textarea{
  /* border: 1px solid #eee; */
  font-size: 14px;
  padding-left: 10px;
  margin-left:10px;
  /* width: 90%; */
  max-width: 930px;
}
/* .row-item-select{
  width: 60%;
} */
.row-opt-but{
  width: 161px;
  height: 50px;
  border: 1px solid #1D65A8;
  background-color: #fff;
  color: #1D65A8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
}
.row-opt-but:hover{
  background-color: #1D65A8;
  color: #fff;
}
</style>


